import type { Track } from '../interfaces/track';

const coerceWorkId = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed ? trimmed : undefined;
};

export const resolveTrackWorkId = (track: Track | Spotify.Track): string | undefined => {
  const buckets: Array<Record<string, any> | undefined> = [
    track as Record<string, any>,
    (track as any)?.metadata,
    (track as any)?.classical,
    (track as any)?.catalog,
    (track as any)?.catalogMetadata,
  ];

  for (const bucket of buckets) {
    if (!bucket || typeof bucket !== 'object') continue;
    const direct = coerceWorkId(bucket.workId ?? bucket.work_id);
    if (direct) return direct;

    const nestedWork = bucket.work;
    if (nestedWork && typeof nestedWork === 'object') {
      const nested = coerceWorkId(
        nestedWork.id ?? nestedWork.workId ?? nestedWork.work_id ?? nestedWork.slug
      );
      if (nested) return nested;
    }
  }

  return undefined;
};
